import { db } from '../db/db.js';
export default{
    data(){
        return{

        }
    },
    methods: {
        //批量添加监控数据
        async addBatchMonitorData(data){
            let res = await db.monitor.bulkAdd(data);
            return res;
        },
        //添加监控数据
        async addMonitorData(data){
            let res = await db.monitor.add(data);
            return res;
        },
        //获取监控数据
        async getMonitorData(){
            let data = await db.monitor.toArray();
            return data.filter(item => item.status == 1&&!item.startTime);
        },
        //获取监控数据
        async getMonitorDataStarted(){
            let data = await db.monitor.toArray();
            return data.filter(item => item.startTime || item.status == 4 ||item.isClaim);
        },
        //获取监控数据
        async getMonitorDataById(pickNumber){
            let data = await db.monitor.get(pickNumber);
            return data;
        },
        //更新监控数据
        async updateMonitorData(data){
            let res = await db.monitor.update(data.pickNumber, data);
            return res;
        },
        //删除监控数据
        async deleteMonitorData(pickNumber){
            let res = await db.monitor.delete(pickNumber);
            return res;
        },
        //清空监控数据
        async clearMonitorData(){
            let res = await db.monitor.clear();
            return res;
        },
        //根据条件移除，fileList值为空，或不存在的记录
        async removeMonitorFileListData(){
            //批量删除 fileList 值为空的记录
            const filter = await db.monitor.filter(monitor => !monitor.fileList).toArray();
            const res = await db.monitor.bulkDelete(filter.map(monitor => monitor.pickNumber));
            return res;
        },

    },
    created() {
        // 在应用初始化时执行一次数据迁移
        db.monitor
            .where('id').above(0) // 找出所有旧数据
            .each(record => {
                if (record.pickNumber && !record._migrated) {
                    db.monitor.update(record.pickNumber, {
                        ...record,
                        _migrated: true // 标记已迁移
                    });
                }
            });
    },
}